import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';

const FIELD_LABEL = { email: 'Correo', phone: 'WhatsApp', church: 'Iglesia', pastor: 'Pastor', city: 'Ciudad', country: 'País' };

export function ImportCsvButton({ campaignId, onDone }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const { data } = await api.post(`/campaigns/${campaignId}/import`, fd);
      const map = Object.entries(data.mapping).map(([k, h]) => `${FIELD_LABEL[k]} ← “${h}”`).join(' · ');
      toast.success(`Importadas ${data.imported} congregaciones`, {
        description: `Duplicadas: ${data.duplicates} · Sin contacto: ${data.skipped} · Correos inválidos: ${data.invalid_emails}. Columnas: ${map}`,
        duration: 9000,
      });
      onDone();
    } catch (e) {
      toast.error(errText(e, 'No se pudo importar el CSV'));
    } finally {
      setBusy(false);
      ref.current.value = '';
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept=".csv,text/csv" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="contacts-import-input" />
      <Button variant="outline" onClick={() => ref.current.click()} disabled={busy} data-testid="contacts-import-button">
        <Upload className="h-4 w-4 mr-1" />{busy ? 'Importando...' : 'Cargar CSV'}
      </Button>
    </>
  );
}
